var _a;
import { createStore } from 'redux';
import rootReducer from './reducer';
import { debounce } from '@debbie/common/dist/util';
import { getFilterFromLocalStorage, persistFiltersToLocalStorage, } from './insights/localStorage';
const initialSelectedOwner = (_a = JSON.parse(localStorage.getItem('selectedOwners') || '[]')) === null || _a === void 0 ? void 0 : _a[0];
const initialState = {
    caseFilter: getFilterFromLocalStorage(initialSelectedOwner),
};
const store = createStore(rootReducer, initialState, 
// @ts-ignore
window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
store.subscribe(() => {
    debounce('persistCaseFilter', () => {
        var _a;
        const state = store.getState();
        persistFiltersToLocalStorage((_a = state.selectedOwners) === null || _a === void 0 ? void 0 : _a[0], state.caseFilter);
    }, 300);
});
export default store;
//# sourceMappingURL=store.js.map